import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useAuthStore = create(
  persist(
    (set) => ({
      token: null,
      user: null, // { loginId, userName, plantId, plantName, themeColor, moduleList }
      isAuthenticated: false,

      setAuth: (token, user) => set({ token, user, isAuthenticated: true }),
      
      logout: () => set({ token: null, user: null, isAuthenticated: false }),
      
      updateTheme: (color) => set((state) => ({
        user: state.user ? { ...state.user, themeColor: color } : null
      }))
    }),
    {
      name: 'manufacturing-auth-storage', // key in localStorage
    }
  )
);

export default useAuthStore;